export type SearchKey = 'Disclaimer' | 'Placeholder' | 'Search' | 'SearchModal' | 'SearchWord' | 'TrySearch';

interface DictionaryFunctions {
	get(key: SearchKey): string;
}

export const SearchItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: SearchKey): string => {
			switch (key) {
				case 'Disclaimer':
					return getValue(
						'Search.Disclaimer',
						'Skriv ikke personlige oplysninger (fx dit cpr-nr.). Vi gemmer søgninger til statistik, så vi løbende kan forbedre søgefunktionen.',
					);
				case 'Placeholder':
					return getValue('Search.Placeholder', 'Hvad søger du?');
				case 'Search':
					return getValue('Search.Search', 'Søg');
				case 'SearchModal':
					return getValue('Search.SearchModal', 'Søge Modal');
				case 'SearchWord':
					return getValue('Search.SearchWord', 'Søgeord');
				case 'TrySearch':
					return getValue('Search.TrySearch', 'Prøv eventuelt at søge');
			}
		},
	};
};
